/**
 * * This function create a slug friendily to use in your web application
 * @param {string} value
 * @returns {string} cleaned slug
 * @see {@link https://gist.github.com/codeguy/6684588}
 */
export function slugify (value) {
  return value
    .normalize('NFKD')
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .trim()
    .replace(/[-\s]+/g, '-')
}
